import { Styles } from 'jss';
import merge from 'lodash/merge';

import { commonStyles } from './common.styles';
import { AdSlotFormatSizeMap } from '../../constants';
import { AdSlotFormatEnum } from '../../dto/recs.dto';
import { StylesDataType } from '../../types';

export const linkStyles: Styles<string, StylesDataType> = {
  outerContainer: (data: StylesDataType): object => merge({}, {
    ...commonStyles.outerContainer(data),
    padding: '4px 0 0 4px !important',
  }, data.style?.outerContainer ?? {}),

  container: (data: StylesDataType): object => merge({}, {
    ...commonStyles.container(data),
    width: AdSlotFormatSizeMap[data.format].width,
    height: AdSlotFormatSizeMap[data.format].height,

    '&:hover $footer': {
      color: '#000000 !important',

      '& $footerLogo svg > path:first-child': {
        fill: '#CA2127 !important',
      },

      '& $footerLogo svg > g.text': {
        fill: '#16325c !important',
      },

      '& $footerCog svg > g > path': {
        fill: '#000000 !important',
      },
    },
  }, data.style?.container ?? {}),

  heading: (data: StylesDataType): object => merge({}, {
    fontSize: '14px !important',
    fontWeight: '700 !important',
    marginBottom: '20px !important',
    paddingTop: '8px !important',
  }, data.style?.heading ?? {}),

  sections: (data: StylesDataType): object => merge({}, {
    ...commonStyles.sections(data),
    flexDirection: (
      data.format === AdSlotFormatEnum.AUTO
        ? 'row'
        : (AdSlotFormatSizeMap[data.format].width > AdSlotFormatSizeMap[data.format].height ? 'row' : 'column')
    ),
  }, 'sections' in data.style ? data.style?.sections : {}),

  listItem: (data: StylesDataType): object => merge({}, {
    ...commonStyles.listItem(data),
    marginBottom: '12px !important',
  }, data.style?.item ?? {}),

  listItemLink: (data: StylesDataType): object => merge({}, {
    ...commonStyles.listItemLink(data),
    color: '#000000 !important',
    '&:hover': {
      textDecoration: 'underline !important',

      '& svg > g > path': {
        stroke: '#000000 !important',
      },
    },
  }, data.style?.itemLink ?? {}),

  listItemTitle: (data: StylesDataType): object => merge({}, {
    display: 'inline-block !important',
  }, data.style?.itemTitle ?? {}),

  listItemTitleExternalLinkIcon: (data: StylesDataType): object => merge({}, {
    display: 'inline-block !important',
    marginLeft: '2px !important',
    verticalAlign: '-3px !important',
    cursor: 'pointer !important',
    '& svg': {
      height: '14px !important',
      width: '14px !important',
    },
    '&:hover': {
      cursor: 'pointer !important',
    },
  }, 'itemTitleExternalLinkIcon' in data.style ? data.style?.itemTitleExternalLinkIcon : {}),

  listItemMeta: (data: StylesDataType): object => merge({}, {
    color: '#a2b1b6 !important',
    marginTop: '2px !important',
    '& a': {
      color: '#a2b1b6 !important',
      textDecoration: 'none !important',
      '&:hover': {
        textDecoration: 'underline !important',
      },
    },
  }, data.style?.itemMeta ?? {}),

  listItemSubtitle: (data: StylesDataType): object => merge(
    {},
    {},
    data.style?.itemSubtitle,
  ),
  listItemAuthors: (data: StylesDataType): object => merge(
    {},
    {},
    data.style?.itemAuthors,
  ),
  listItemPublicationName: (data: StylesDataType): object => merge(
    {},
    {},
    'itemPublicationName' in data.style ? data.style?.itemPublicationName : {},
  ),
  listItemPublicationDate: (data: StylesDataType): object => merge(
    {},
    {},
    'itemPublicationDate' in data.style ? data.style?.itemPublicationDate : {},
  ),

  footer: (data: StylesDataType): object => merge({}, {
    ...commonStyles.footer(data),
    borderTop: '2px solid #e9eeef !important',
    color: '#cad5d9 !important',
    fontFamily: 'SF Pro Display, Arial, "Helvetica CY", sans-serif !important',
    fontSize: '14px !important',
    margin: '13px 0 15px 0 !important',
    padding: '15px 0 0 !important',
  }, data.style?.footer ?? {}),

  footerLeft: (data: StylesDataType): object => merge({}, {
    '& a': {
      display: 'flex !important',
      alignItems: 'center !important',
      color: 'inherit !important',
      textDecoration: 'none !important',

      '&:hover': {
        textDecoration: 'none !important',
      },
    },
  }, data.style.footerLeft ?? {}),

  footerLogo: (data: StylesDataType): object => merge({}, {
    minWidth: '70px !important',
    height: '22px !important',
    marginLeft: '5px !important',
    verticalAlign: 'middle !important',
    '& svg': {
      height: '22px !important',
      width: 'auto !important',
    },
  }, 'footerLogo' in data.style ? data.style.footerLogo : {}),
}
